import { client, clientProxy } from '@/services/apolloclient'
import Vue from 'vue'
export class QueryCache {
  constructor(expireTime) {
    this.expireTime = expireTime || 1000 * 30 // 30 seconds
  }

  get(key) {
    const data = Vue.prototype.$cache.data[key]
    if (data && data.expireTime > Date.now()) return data
    else {
      this.delete(key)
      return null
    }
  }

  set(key, value) {
    Vue.prototype.$cache.data[key] = { data: value, expireTime: Date.now() + this.expireTime }
    if (this.size().length > Vue.prototype.$cache.resourceLimit) {
      this.clear()
    }
  }

  delete(key) {
    delete Vue.prototype.$cache.data[key]
  }

  clear() {
    const keys = this.keys()
    /**
     * Clears the cache by deleting the oldest entries until the cache size is within the resource limit.
     */
    const listClear = keys.slice(0, keys.length - Vue.prototype.$cache.resourceLimit)
    listClear.forEach((key) => {
      this.delete(key)
    })
    /**
     * Deletes any entries that have expired.
     */
    keys.forEach((key) => {
      const data = Vue.prototype.$cache.data[key]
      if (data.expireTime < Date.now()) this.delete(key)
    })
  }

  keys() {
    return Object.keys(Vue.prototype.$cache.data)
  }

  size() {
    return Object.keys(Vue.prototype.$cache.data).length
  }

  generateKey(key, variables) {
    return `${key}-${JSON.stringify(variables)}`
  }

  async fetch(query, variables, reportKey, clientName) {
    const key = this.generateKey(reportKey, variables)
    const data = this.get(key)
    if (data) return JSON.parse(data.data)
    else {
      let selectedClient = client
      if (clientName === 'clientProxy') {
        selectedClient = clientProxy
      }

      const res = await selectedClient.query({
        query,
        fetchPolicy: 'no-cache',
        variables,
      })
      this.set(key, JSON.stringify(res.data))
      return res.data
    }
  }
}
